import { memo } from "react";
import  { type LottieOptions } from "lottie-react";
import Lottie from "lottie-react";
import {type  AnimationsType, getAnimationByType } from "../molecules/Animations/Animations";

export type AnimationProps = {
  type: AnimationsType;
} & Omit<LottieOptions, "animationData">

export const Animation = memo(({ type, ...props }: AnimationProps) => (
  <Lottie
    animationData={getAnimationByType(type)}
    loop={true}
    autoplay={true}
    rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
    className="mx-auto flex items-center justify-center"
    style={{
      height: props.height,
      width: props.width,
      ...props.style,
    }}
    {...props}
  />
));

Animation.displayName = "Animation";
